import { useMutation, UseMutationResult } from 'react-query';
import {
  getWhatIdTopics,
  getWhatIfAges,
  getWhatIfLanguages,
  getWhatIfStory,
  getWhatIfStoryView,
  getWhatIfStoryWithFile,
  submitWhatIfStory,
  WhatIfStoryViewRequest,
} from './services';
import type { MutationError } from '../../type';
import {
  WhatIfTopic,
  WhatIfAgesResponse,
  WhatIfLangResponse,
  WhatIfTopicsRequest,
  WhatIfStoriesResponse,
  IWhatIfStory,
  WhatIfStoriesRequest,
  WhatIfStorySubmitResponse,
  WhatIfStorySubmitRequest,
  WhatIfStoryViewResponse,
} from './types';

export const useGetWhatIfAges = (): UseMutationResult<
  WhatIfAgesResponse,
  MutationError,
  void
> => {
  return useMutation({
    mutationFn: () => {
      return getWhatIfAges();
    },
  });
};

export const useGetWhatIfLangs = (): UseMutationResult<
  WhatIfLangResponse,
  MutationError,
  void
> => {
  return useMutation({
    mutationFn: () => {
      return getWhatIfLanguages();
    },
  });
};

export const useGetWhatIfTopics = (): UseMutationResult<
  WhatIfTopic,
  MutationError,
  WhatIfTopicsRequest
> => {
  return useMutation({
    mutationFn: (variables: WhatIfTopicsRequest) => {
      return getWhatIdTopics(variables);
    },
  });
};

export const useGetWhatIfStory = (): UseMutationResult<
  WhatIfStoriesResponse,
  MutationError,
  WhatIfStoriesRequest
> => {
  return useMutation({
    mutationFn: (variables: WhatIfStoriesRequest) => {
      return getWhatIfStory(variables);
    },
  });
};

export const useSubmitWhatIfStory = (): UseMutationResult<
  WhatIfStorySubmitResponse,
  MutationError,
  WhatIfStorySubmitRequest
> => {
  return useMutation({
    mutationFn: (variables: WhatIfStorySubmitRequest) => {
      return submitWhatIfStory(variables);
    },
  });
};

export const useGetWhatIfStoryWithFile = (): UseMutationResult<
  any,
  MutationError,
  any
> => {
  return useMutation({
    mutationFn: (variables: FormData) => {
      return getWhatIfStoryWithFile(variables);
    },
  });
};

export const useGetWhatIfStoryView = (): UseMutationResult<
  WhatIfStoryViewResponse[],
  MutationError,
  WhatIfStoryViewRequest
> => {
  return useMutation({
    mutationFn: (variables: WhatIfStoryViewRequest) => {
      return getWhatIfStoryView(variables);
    },
  });
};
